<template>
  <v-flex xs12 class="clear pt-3">
        <message-templ :messageTitle="title" :messageType="name" :messageSubTitle="subTitle" :totlePage="totlePage" :messageLists="remind.list" @refreshList = "refreshList"></message-templ>
  </v-flex>
</template>
<script>
import { getTutorMoodleMsgList } from '@/api/message.js'
import { mapGetters } from 'vuex'
import messageTempl from '../message/_messageTempl'
export default {
  name: 'moodleMessage',
  data: () => ({
    name: 'remind',
    title: 'Moodle Messages',
    subTitle: '',
    currentPage: 1,
    searchKey: '',
    totlePage: 1,
    remind: {
      list: []
    },
    limit:20,
    offset:0,
    keyOne:{
      Key:'',
      Number:0,
      Items:[]
    },
    keyTwo:{
      Key:'',
      Number:0,
      Items:[]
    },
  }),
  components: {
    messageTempl
  },
  computed:{
      ...mapGetters(['user']),
  },
  mounted () {
    this.search()
  },
  methods: {
    search () {
      let start = this.getThreeMonthBefore();
      let end = parseInt(new Date().getTime()/1000);
      getTutorMoodleMsgList(this.limit,this.offset,start,end).then(res=>{
        if(res.data.ErrorCode!==0 || !res.data.Body) return
        let data = res.data.Body
        this.totlePage = data.TotalPages
        data.Items.forEach((item)=>{
          let createTime = new Date(item.CreateTime).getTime();
          if(end-parseInt(createTime/1000)<604800){
            this.keyOne.Key = 'Within a week'
            this.keyOne.Number++
            this.keyOne.Items.push({Desc:item.Title,Time:createTime,Text:item.Content,Index:-1})
          }else{
            this.keyTwo.Key = 'A week away'
            this.keyTwo.Number++
            this.keyTwo.Items.push({Desc:item.Title,Time:createTime,Text:item.Content,Index:-1})
          }
        })
        if(this.keyOne.Number!==0) this.remind.list.push(this.keyOne);
        if(this.keyTwo.Number!==0) this.remind.list.push(this.keyTwo);
        
      })
    },
    getThreeMonthBefore(){
      var resultDate,year,month,date,hms;
      var currDate = new Date();
      year = currDate.getFullYear();
      month = currDate.getMonth()+1;
      date = currDate.getDate();
      hms = currDate.getHours() + ':' + currDate.getMinutes() + ':' + (currDate.getSeconds() < 10 ? '0'+currDate.getSeconds() : currDate.getSeconds());
      switch(month)
      {
        case 1:
        case 2:
        case 3:
          month += 9;
          year--;
          break;
        default:
          month -= 3;
          break;
      }
      month = (month < 10) ? ('0' + month) : month;
      resultDate = year + '-'+month+'-'+date+' ' + hms;
      return parseInt(new Date(resultDate).getTime()/1000);
    },
    refreshList (key, page) {
      this.currentPage = page
      this.searchKey = key
      this.offset = (page-1)*20
      this.search()
    }
  }
}
</script>
